<template>
  <div class="wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%]">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.SMS.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.SMS.DESC')"
    />
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label>
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL') }}
        <select v-model="provider">
          <option value="twilio">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.TWILIO') }}
          </option>
          <option value="360dialog">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.BANDWIDTH') }}
          </option>
          <option value="jio_sms">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.JIO_SMS') }}
          </option>
        </select>
      </label>
    </div>
    <twilio v-if="provider === 'twilio'" type="sms" />
    <bandwidth-sms v-else-if="provider === '360dialog'" />
    <jio-sms v-else-if="provider === 'jio_sms'" :channel="channel" />
  </div>
</template>

<script>
import PageHeader from '../../SettingsSubPageHeader';
import BandwidthSms from './BandwidthSms.vue';
import Twilio from './Twilio';
import JioSms from './JioSms';

export default {
  components: {
    PageHeader,
    Twilio,
    BandwidthSms,
    JioSms,
  },
  data() {
    return {
      provider: 'twilio',
    };
  },
};
</script>
